<div class="banner d-lg-flex d-none">
  <h1>{{ 'auction.page.title' | translate }}</h1>
</div>

<div class="d-lg-none">
  <fgb-barcode></fgb-barcode>
</div>

<fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>

<div class="container mt-3">
  <fgbcl-auction-list></fgbcl-auction-list>
</div>
